export const money = (n) => {
  const v = Number(n);
  if (Number.isNaN(v)) return "$0.00";
  return v.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

const num = (v) => {
  const n = parseFloat(v);
  return Number.isNaN(n) ? 0 : n;
};

export const lineItemAmount = (row) => num(row?.qty || 0) * num(row?.unit_price || 0);

export const lineItemsSubtotal = (items) =>
  (Array.isArray(items) ? items : []).reduce((sum, r) => sum + lineItemAmount(r), 0);

export const changeItemsTotal = (items) =>
  (Array.isArray(items) ? items : []).reduce((sum, r) => sum + num(r?.amount || 0), 0);

// Generic totals for invoice / estimate / contract, and the change-order balance model.
export const computeTotals = (type, data = {}) => {
  if (type === "change_total") {
    const original = num(data.original_contract_price);
    const previouslyPaid = num(data.previously_paid);
    const netChange = changeItemsTotal(data.change_items);
    const origBalanceRemaining = original - previouslyPaid;
    const revisedContractValue = original + netChange;
    const currentBalanceRemaining = revisedContractValue - previouslyPaid;
    return { original, previouslyPaid, netChange, origBalanceRemaining, revisedContractValue, currentBalanceRemaining };
  }
  const subtotal = lineItemsSubtotal(data.line_items);
  const rate = num(data.tax_rate);
  const tax = +(subtotal * (rate / 100)).toFixed(2);
  const total = +(subtotal + tax).toFixed(2);
  return { subtotal, rate, tax, total };
};
